"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _header = _interopRequireDefault(require("../header"));

var _axios = _interopRequireDefault(require("axios"));

var _AlertComponent = _interopRequireDefault(require("@insided/shared/uikit/AlertComponent"));

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _Switcher = _interopRequireDefault(require("../../preact-components/control/Switcher"));

var _Checkbox = _interopRequireDefault(require("@insided/shared/uikit/Checkbox"));

var _Tooltip = _interopRequireDefault(require("@insided/shared/uikit/Tooltip"));

var _common = require("@insided/shared/utils/common");

var _Section = require("../ui-components/Section");

var _classnames = _interopRequireDefault(require("classnames"));

var _constants = require("@insided/shared/constants");

var _LabelText = _interopRequireDefault(require("@insided/shared/uikit/LabelText"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var CommunityConfiguration = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(CommunityConfiguration, _Component);

  var _super = _createSuper(CommunityConfiguration);

  function CommunityConfiguration(props) {
    var _this;

    (0, _classCallCheck2.default)(this, CommunityConfiguration);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setAIProcessorAgreed", function () {
      var _this$state = _this.state,
          isAIProcessorAgreed = _this$state.isAIProcessorAgreed,
          modules = _this$state.modules;

      _this.setState({
        isAIProcessorAgreed: !isAIProcessorAgreed,
        modules: Object.assign(modules, {
          aiFeatures: false
        })
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loadProject", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _axios.default.get('/emailCampaign/project').then(function (response) {
                _this.setState({
                  project: response.data,
                  emailCampaignSeatLimit: response.data.monthly_user_limit,
                  isCampaignsEnabled: true
                });
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "saveProjectUserLimit", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var _this$state2, isCampaignsEnabled, emailCampaignSeatLimit;

      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$state2 = _this.state, isCampaignsEnabled = _this$state2.isCampaignsEnabled, emailCampaignSeatLimit = _this$state2.emailCampaignSeatLimit;

              if (isCampaignsEnabled) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return");

            case 3:
              _context2.next = 5;
              return _axios.default.post('/emailCampaign/setUserLimit', {
                monthly_user_limit: emailCampaignSeatLimit !== null && emailCampaignSeatLimit !== void 0 ? emailCampaignSeatLimit : 0
              });

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleDeleteInstance", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      var response;
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;

              _this.setState({
                isAutopilotInstanceInCreation: true
              });

              _context3.next = 4;
              return _axios.default.delete('/integration/autopilot/delete');

            case 4:
              response = _context3.sent;

              if (response.status === 204) {
                _this.setState({
                  isAutopilotInstanceCreated: false,
                  isAutopilotInstanceInCreation: false,
                  messageType: 'success',
                  message: 'Successfully deleted Autopilot instance'
                });
              }

              _context3.next = 11;
              break;

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](0);

              _this.setState({
                messageType: 'error',
                message: 'Failed to delete Autopilot instance'
              });

            case 11:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 8]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleOnboardInstance", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
      var _response$data, _response$data$data, response;

      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;

              _this.setState({
                isAutopilotInstanceInCreation: true
              });

              _context4.next = 4;
              return _axios.default.post('/integration/autopilot/onboard');

            case 4:
              response = _context4.sent;

              if ((_response$data = response.data) !== null && _response$data !== void 0 && (_response$data$data = _response$data.data) !== null && _response$data$data !== void 0 && _response$data$data.success) {
                _this.setState({
                  isAutopilotInstanceCreated: false,
                  isAutopilotInstanceInCreation: true,
                  messageType: 'success',
                  message: 'Autopilot instance creation initiated'
                });
              }

              _context4.next = 11;
              break;

            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](0);

              _this.setState({
                isAutopilotInstanceCreated: false,
                isAutopilotInstanceInCreation: false,
                messageType: 'error',
                message: 'Failed to create Autopilot instance'
              });

            case 11:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 8]]);
    })));
    _this.state = _objectSpread(_objectSpread({}, props.config), {}, {
      messageType: null,
      message: '',
      emailCampaignSeatLimit: 0,
      isCampaignsEnabled: false,
      isAIProcessorAgreed: _common.common.isModuleActive('aiFeatures'),
      isAutopilotInstanceCreated: false,
      isAutopilotInstanceInCreation: false,
      modules: {
        salesforceCrm: _common.common.isModuleActive('salesforceCrm'),
        salesforceFederatedSearch: _common.common.isModuleActive('salesforceFederatedSearch'),
        salesforceCaseEscalation: _common.common.isModuleActive('salesforceCaseEscalation'),
        salesforceSyncAccountData: _common.common.isModuleActive('salesforceSyncAccountData'),
        zendeskFederatedSearch: _common.common.isModuleActive('zendeskFederatedSearch'),
        zendeskTicketEscalation: _common.common.isModuleActive('zendeskTicketEscalation'),
        pointSystem: _common.common.isModuleActive('pointSystem'),
        rank: _common.common.isModuleActive('rank'),
        customCss: _common.common.isModuleActive('customCss'),
        thirdPartyScripts: _common.common.isModuleActive('thirdPartyScripts'),
        group: _common.common.isModuleActive('group'),
        gainsight: _common.common.isModuleActive('gainsight'),
        integrationsApi: _common.common.isModuleActive('integrationsApi'),
        integrationsConnectorsAndSecrets: _common.common.isModuleActive('integrationsConnectorsAndSecrets'),
        integrationsWidgetSources: _common.common.isModuleActive('integrationsWidgetSources'),
        aiEvolutionReplyBot: _common.common.isModuleActive('aiEvolutionReplyBot'),
        productAreas: _common.common.isModuleActive('productAreas'),
        productUpdates: _common.common.isModuleActive('productUpdates'),
        articleToProductUpdateConversion: _common.common.isModuleActive('articleToProductUpdateConversion'),
        ideationV2: _common.common.isModuleActive('ideationV2'),
        privateGroup: _common.common.isModuleActive('privateGroup'),
        skilljarFederatedSearch: _common.common.isModuleActive('skilljarFederatedSearch'),
        freshdeskFederatedSearch: _common.common.isModuleActive('freshdeskFederatedSearch'),
        freshdeskV2: _common.common.isModuleActive('freshdeskV2'),
        productboardIntegration: _common.common.isModuleActive('productboardIntegration'),
        analyticsV2SelfService: _common.common.isModuleActive('analyticsV2SelfService'),
        exportRevamp: _common.common.isModuleActive('exportRevamp'),
        federatedSearchApi: _common.common.isModuleActive('federatedSearchApi'),
        hiddenGroup: _common.common.isModuleActive('hiddenGroup'),
        emailCampaigns: _common.common.isModuleActive('emailCampaigns'),
        intercomFederatedSearch: _common.common.isModuleActive('intercomFederatedSearch'),
        intercomCreateConversations: _common.common.isModuleActive('intercomCreateConversations'),
        gainsightPlatformSso: _common.common.isModuleActive('gainsightPlatformSso'),
        aiFeatures: _common.common.isModuleActive('aiFeatures'),
        onDemandTranslations: _common.common.isModuleActive('onDemandTranslations'),
        contentInPreferredLanguage: _common.common.isModuleActive('contentInPreferredLanguage'),
        theLoops: _common.common.isModuleActive('theLoops')
      }
    });
    _this.onSave = _this.onSave.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(CommunityConfiguration, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.loadProject();
    }
  }, {
    key: "onSave",
    value: function () {
      var _onSave = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
        var _this2 = this;

        var isModule, modules, _this$state$seatLimit, _err$response$data$er, _err$response$data, message;

        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this.setState({
                  messageType: ''
                });

                isModule = function isModule(key) {
                  return key in _this2.state.modules;
                };

                modules = Object.keys(this.state.modules) // get all modules names
                .filter(isModule).filter(function (key) {
                  return _this2.state.modules[key] !== _common.common.isModuleActive(key);
                }) // filter out those not changed
                .reduce(function (result, key) {
                  // get an object with changed modules
                  result[key] = _this2.state.modules[key];
                  return result;
                }, {});
                this.setState({
                  messageType: null
                });
                _context5.prev = 4;
                _context5.next = 7;
                return _axios.default.post('/settings/configuration/save', {
                  config: {
                    seatLimit: (_this$state$seatLimit = this.state.seatLimit) !== null && _this$state$seatLimit !== void 0 ? _this$state$seatLimit : 0
                  },
                  modules: modules
                });

              case 7:
                _context5.next = 9;
                return this.saveProjectUserLimit();

              case 9:
                this.setState({
                  messageType: 'success',
                  message: 'Community configuration successfully saved!'
                });
                window.location.reload();
                _context5.next = 17;
                break;

              case 13:
                _context5.prev = 13;
                _context5.t0 = _context5["catch"](4);
                message = (_err$response$data$er = (_err$response$data = _context5.t0.response.data) === null || _err$response$data === void 0 ? void 0 : _err$response$data.errors[0]) !== null && _err$response$data$er !== void 0 ? _err$response$data$er : _context5.t0.response.data;
                this.setState({
                  messageType: 'error',
                  message: message
                });

              case 17:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[4, 13]]);
      }));

      function onSave() {
        return _onSave.apply(this, arguments);
      }

      return onSave;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$state3 = this.state,
          messageType = _this$state3.messageType,
          message = _this$state3.message,
          seatLimit = _this$state3.seatLimit,
          modules = _this$state3.modules,
          emailCampaignSeatLimit = _this$state3.emailCampaignSeatLimit,
          isAIProcessorAgreed = _this$state3.isAIProcessorAgreed,
          isAutopilotInstanceInCreation = _this$state3.isAutopilotInstanceInCreation,
          isAutopilotInstanceCreated = _this$state3.isAutopilotInstanceCreated,
          loopsSubtenantUrl = _this$state3.loopsSubtenantUrl;
      return (0, _preact.h)("div", {
        className: "community-configuration-page"
      }, (0, _preact.h)(_header.default, {
        title: "Modules",
        hasBreadcrumb: false,
        saveCallback: this.onSave
      }), Boolean(messageType) && (0, _preact.h)(_AlertComponent.default, {
        messageType: messageType,
        message: message,
        sticky: true,
        isVisibleFor: 5000
      }), (0, _preact.h)("div", {
        className: "community-configuration"
      }, (0, _preact.h)(_Section.Section, {
        title: "Seat limit"
      }, (0, _preact.h)(_InputGroup.default, {
        newStyle: true,
        id: "seat-limit-for-this-instance",
        title: "Seat limit",
        type: "number",
        onChange: function onChange(event) {
          _this3.setState({
            seatLimit: parseInt(event.target.value)
          });
        },
        meta: "Enter the seat limit for this instance below. To set an unlimited number of seats, enter 0.",
        value: seatLimit
      }))), (0, _preact.h)(_Section.Section, {
        title: "AI Features"
      }, (0, _preact.h)(_Tooltip.default, {
        position: "left",
        left: 0,
        top: 35,
        customClasses: isAIProcessorAgreed ? 'ai-features-tooltip-disabled' : '',
        trigger: (0, _preact.h)(_Switcher.default, {
          customClass: "panel-switch",
          labelCustomClass: "panel-switch-label",
          label: (0, _preact.h)(_LabelText.default, {
            label: "Enable AI Features",
            description: "This toggle will allow customers to enable and disable AI features themselves. By default, all AI features in Control will be enabled once this toggle is on. All AI features in Destination will be disabled by default to prevent unwanted end-user impact."
          }),
          on: modules.aiFeatures,
          onChange: function onChange() {
            return _this3.setState({
              modules: Object.assign(modules, {
                aiFeatures: !modules.aiFeatures
              })
            });
          },
          disable: !isAIProcessorAgreed
        }),
        tooltipMessage: "Cannot enable this without checking the prerequisite"
      }), (0, _preact.h)(_Checkbox.default, {
        label: "Prerequisite: This customer has agreed with adding Microsoft as a subprocessor to support these AI features.",
        onUpdate: this.setAIProcessorAgreed,
        qaClasses: "qa-ai-agreed",
        checked: isAIProcessorAgreed,
        customClass: "ai-features-agreed-checkbox"
      })), (0, _preact.h)("div", {
        className: "community-configuration"
      }, (0, _preact.h)(_Section.Section, {
        title: "Email campaigns"
      }, (0, _preact.h)(_Switcher.default, {
        customClass: "panel-switch",
        labelCustomClass: "panel-switch-label",
        on: modules.emailCampaigns,
        onChange: function onChange() {
          return _this3.setState({
            modules: Object.assign(modules, {
              emailCampaigns: !modules.emailCampaigns
            })
          });
        },
        label: (0, _preact.h)("div", null, (0, _preact.h)(_LabelText.default, {
          label: "Email campaigns",
          description: (0, _preact.h)("div", null, (0, _preact.h)("p", null, "The Email Campaigns feature allows you to send one-off and automated email campaigns to your users based on specific user criteria (eg, role, registration date, etc.). After toggling on this feature and refreshing the page, you can find Email Campaigns in the Email section."), (0, _preact.h)("p", null, "Switching off Email Campaigns will stop all active automated campaigns and cancel scheduled campaigns. All emails and metrics will still be accessible if the module is enabled again at a later time."), modules.emailCampaigns && (0, _preact.h)("p", null, "Each package has a limit on the monthly reached users (10k for Professional, 25k for Business and 100k for Enterprise). This limit will be shown in the UI on the Email Campaigns overview, and customers can't exceed this number when creating an email campaign. If the customer exceeds this number, customers can either upgrade to another package, or increase their allowed recipient count."))
        }), modules.emailCampaigns && (0, _preact.h)("div", {
          className: (0, _classnames.default)('form-group', 'form-group--new-style', 'module-email-campaign')
        }, (0, _preact.h)("label", {
          htmlFor: "module-email-campaign-input"
        }, "Allowed monthly reached users"), (0, _preact.h)("div", {
          className: "module-email-campaign-input"
        }, (0, _preact.h)("input", {
          value: emailCampaignSeatLimit,
          className: "form-control",
          id: "module-email-campaign-input",
          type: "number",
          onChange: function onChange(event) {
            var _event$target$value, _event$target;

            _this3.setState({
              emailCampaignSeatLimit: parseInt((_event$target$value = event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value) !== null && _event$target$value !== void 0 ? _event$target$value : 0)
            });
          }
        }), (0, _preact.h)("span", null, "Monthly reached users"))))
      }))), (0, _preact.h)(_Section.Section, {
        title: "Salesforce"
      }, (0, _preact.h)(_Switcher.default, {
        customClass: "panel-switch",
        labelCustomClass: "panel-switch-label",
        label: (0, _preact.h)(_LabelText.default, {
          label: "Import Salesforce Account data to ".concat(_constants.PLATFORM_BRAND_NAME),
          description: "Switching this off will disable the Import Salesforce Account data section on the self-service page in control and stop the integration. Already imported accounts will remain in ".concat(_constants.PLATFORM_BRAND_NAME, ", but will no longer be updated.")
        }),
        on: modules.salesforceSyncAccountData,
        onChange: function onChange() {
          return _this3.setState({
            modules: Object.assign(modules, {
              salesforceSyncAccountData: !modules.salesforceSyncAccountData
            })
          });
        }
      }), (0, _preact.h)(_Switcher.default, {
        customClass: "panel-switch",
        labelCustomClass: "panel-switch-label",
        label: (0, _preact.h)(_LabelText.default, {
          label: "Export community member and activity data to Salesforce",
          description: "Switching this off will disable the Export community data section on the self-service page in control and stop the export integration. Already pushed data will remain in Salesforce. Switching it on will only enable the self-service page."
        }),
        on: modules.salesforceCrm,
        onChange: function onChange() {
          return _this3.setState({
            modules: Object.assign(modules, {
              salesforceCrm: !modules.salesforceCrm
            })
          });
        }
      }), (0, _preact.h)(_Switcher.default, {
        customClass: "panel-switch",
        labelCustomClass: "panel-switch-label",
        label: (0, _preact.h)(_LabelText.default, {
          label: "Federated search",
          description: "Switching this off will disable the federated search section on self-service page in control and exclude salesforce KB from search. Reindexing will stop, but it will not empty existing index. Switching it on will only enable self-service page."
        }),
        on: modules.salesforceFederatedSearch,
        onChange: function onChange() {
          return _this3.setState({
            modules: Object.assign(modules, {
              salesforceFederatedSearch: !modules.salesforceFederatedSearch
            })
          });
        }
      }), (0, _preact.h)(_Switcher.default, {
        customClass: "panel-switch",
        labelCustomClass: "panel-switch-label",
        label: (0, _preact.h)(_LabelText.default, {
          label: "Case escalation",
          description: "Switching this off will disable the case escalation section on self-service page in control and hide escalation button and links. Escalated topics will remain in Salesforce. Switching it on will only enable self-service page."
        }),
        on: modules.salesforceCaseEscalation,
        onChange: function onChange() {
          return _this3.setState({
            modules: Object.assign(modules, {
              salesforceCaseEscalation: !modules.salesforceCaseEscalation
            })
          });
        }
      })), (0, _preact.h)(_Section.Section, {
        title: "Gainsight"
      }, (0, _preact.h)(_Switcher.default, {
        customClass: "panel-switch",
        labelCustomClass: "panel-switch-label",
        label: (0, _preact.h)(_LabelText.default, {
          label: "CRM integration",
          description: "Switching this off will disable the self-service page in control and stop CRM integration. Data that was pushed prior to disabling the integration will remain in Gainsight. Configuration (S3 bucket credentials) will stay. Switching it on will re-enable integration."
        }),
        on: modules.gainsight,
        onChange: function onChange() {
          return _this3.setState({
            modules: Object.assign(modules, {
              gainsight: !modules.gainsight
            })
          });
        }
      }), (0, _preact.h)(_Switcher.default, {
        customClass: "panel-switch",
        labelCustomClass: "panel-switch-label",
        label: (0, _preact.h)(_LabelText.default, {
          label: "Platform SSO",
          description: "Enable or disable logging in with Gainsight Platform SSO. Enabling this will redirect the login page to the Gainsight SSO login page. Disabling this will revert to the old login flow."
        }),
        on: modules.gainsightPlatformSso,
        onChange: function onChange() {
          return _this3.setState({
            modules: _objectSpread(_objectSpread({}, modules), {}, {
              gainsightPlatformSso: !modules.gainsightPlatformSso
            })
          });
        }
      })), (0, _preact.h)(_Section.Section, {
        title: "Zendesk"
      }, (0, _preact.h)(_Switcher.default, {
        customClass: "panel-switch",
        labelCustomClass: "panel-switch-label",
        label: (0, _preact.h)(_LabelText.default, {
          label: "Federated search",
          description: "Switching this off will disable the federated search section on self-service page in control and exclude zendesk KB from search. Reindexing will stop, but it will not empty existing index. Switching it on will only enable self-service page."
        }),
        on: modules.zendeskFederatedSearch,
        onChange: function onChange() {
          return _this3.setState({
            modules: Object.assign(modules, {
              zendeskFederatedSearch: !modules.zendeskFederatedSearch
            })
          });
        }
      }), (0, _preact.h)(_Switcher.default, {
        customClass: "panel-switch",
        labelCustomClass: "panel-switch-label",
        label: (0, _preact.h)(_LabelText.default, {
          label: "Ticket escalation",
          description: "Switching this off will disable the ticket escalation section on self-service page in control and hide escalation button and links. Escalated topics will remain in Zendesk. Switching it on will only enable self-service page."
        }),
        on: modules.zendeskTicketEscalation,
        onChange: function onChange() {
          return _this3.setState({
            modules: Object.assign(modules, {
              zendeskTicketEscalation: !modules.zendeskTicketEscalation
            })
          });
        }
      })), (0, _preact.h)(_Section.Section, {
        title: "Freshdesk"
      }, (0, _preact.h)(_Switcher.default, {
        customClass: "panel-switch",
        labelCustomClass: "panel-switch-label",
        label: (0, _preact.h)(_LabelText.default, {
          label: "Federated search",
          description: "Switching this off will disable the federated search section on self-service page in control and exclude freshdesk KB from search. Reindexing will stop, but it will not empty existing index. Switching it on will only enable self-service page."
        }),
        on: modules.freshdeskFederatedSearch,
        onChange: function onChange() {
          return _this3.setState({
            modules: Object.assign(modules, {
              freshdeskFederatedSearch: !modules.freshdeskFederatedSearch
            })
          });
        }
      }), (0, _preact.h)(_Switcher.default, {
        customClass: "panel-switch",
        labelCustomClass: "panel-switch-label",
        label: (0, _preact.h)(_LabelText.default, {
          label: "Ticket escalation",
          description: "Switching this off will disable the Freshdesk section on self-service page in Control and hide the create ticket button and escalated ticket links. Created tickets will remain in Freshdesk. Switching it on will only enable self-service page."
        }),
        on: modules.freshdeskV2,
        onChange: function onChange() {
          return _this3.setState({
            modules: Object.assign(modules, {
              freshdeskV2: !modules.freshdeskV2
            })
          });
        }
      })), (0, _preact.h)(_Section.Section, {
        title: "Skilljar"
      }, (0, _preact.h)(_Switcher.default, {
        customClass: "panel-switch",
        labelCustomClass: "panel-switch-label",
        label: (0, _preact.h)(_LabelText.default, {
          label: "Federated search",
          description: "Switching this off will disable the federated search section on self-service page in control and exclude skilljar KB from search. Reindexing will stop, but it will not empty existing index. Switching it on will only enable self-service page."
        }),
        on: modules.skilljarFederatedSearch,
        onChange: function onChange() {
          return _this3.setState({
            modules: Object.assign(modules, {
              skilljarFederatedSearch: !modules.skilljarFederatedSearch
            })
          });
        }
      })), (0, _preact.h)(_Section.Section, {
        title: "Productboard"
      }, (0, _preact.h)(_Switcher.default, {
        customClass: "panel-switch",
        labelCustomClass: "panel-switch-label",
        label: (0, _preact.h)(_LabelText.default, {
          label: "Note creation",
          description: "Switching this off will disable the productboard section on self-service page in Control and hide the create note button and escalated notes links. Created notes will remain in Productboard. Switching it on will only enable self-service page."
        }),
        on: modules.productboardIntegration,
        onChange: function onChange() {
          return _this3.setState({
            modules: Object.assign(modules, {
              productboardIntegration: !modules.productboardIntegration
            })
          });
        }
      })), (0, _preact.h)(_Section.Section, {
        title: "Intercom"
      }, (0, _preact.h)(_Switcher.default, {
        customClass: "panel-switch",
        labelCustomClass: "panel-switch-label",
        label: (0, _preact.h)(_LabelText.default, {
          label: "Federated search",
          description: "Switching this off will disable the federated search section on self-service page in control and exclude Intercom helpdesk content from search. Reindexing will stop, but it will not empty existing index. Switching it on will only enable self-service page."
        }),
        on: modules.intercomFederatedSearch,
        onChange: function onChange() {
          return _this3.setState({
            modules: Object.assign(modules, {
              intercomFederatedSearch: !modules.intercomFederatedSearch
            })
          });
        }
      }), (0, _preact.h)(_Switcher.default, {
        customClass: "panel-switch",
        labelCustomClass: "panel-switch-label",
        label: (0, _preact.h)(_LabelText.default, {
          label: "Create Intercom conversations from community post",
          description: "Switching this off will disable the Intercom panel on self-service page in Control and hide the create conversation and created conversation buttons. Created conversations will remain in Intercom. Switching this on will only enable self-service page."
        }),
        on: modules.intercomCreateConversations,
        onChange: function onChange() {
          return _this3.setState({
            modules: Object.assign(modules, {
              intercomCreateConversations: !modules.intercomCreateConversations
            })
          });
        }
      })), (0, _preact.h)(_Section.Section, {
        title: "Analytics dashboards"
      }, (0, _preact.h)(_Switcher.default, {
        customClass: "panel-switch",
        labelCustomClass: "panel-switch-label",
        label: (0, _preact.h)(_LabelText.default, {
          label: "Self service dashboard",
          description: "Switching this off will disable the ticket data import section on self-service page in control and hide the self-service dashboard. Switching it on will only enable self-service page."
        }),
        on: modules.analyticsV2SelfService,
        onChange: function onChange() {
          return _this3.setState({
            modules: Object.assign(modules, {
              analyticsV2SelfService: !modules.analyticsV2SelfService
            })
          });
        }
      })), (0, _preact.h)(_Section.Section, {
        title: "Gamification"
      }, (0, _preact.h)(_Switcher.default, {
        customClass: "panel-switch",
        labelCustomClass: "panel-switch-label",
        label: (0, _preact.h)(_LabelText.default, {
          label: "Point system",
          description: "Switching this off will disable the self-service point system configuration page in control and disable point system rules. On destination the leaderboard widget will not be displayed in the list of sidebar widgets when c customization. If the leaderboard widget was previously added it will be displayed until  the customer removes this widget."
        }),
        on: modules.pointSystem,
        onChange: function onChange() {
          return _this3.setState({
            modules: Object.assign(modules, {
              pointSystem: !modules.pointSystem
            })
          });
        }
      }), (0, _preact.h)(_Switcher.default, {
        customClass: "panel-switch",
        labelCustomClass: "panel-switch-label",
        label: (0, _preact.h)(_LabelText.default, {
          label: "Rank system",
          description: "Switching this off will disable the self-service page in control to manage ranks. The rank icon, rank titles will not be shown as metadata text in both control and destination in all locations that the user avatar is displayed."
        }),
        on: modules.rank,
        onChange: function onChange() {
          return _this3.setState({
            modules: Object.assign(modules, {
              rank: !modules.rank
            })
          });
        }
      })), (0, _preact.h)(_Section.Section, {
        title: "Customization"
      }, (0, _preact.h)(_Switcher.default, {
        customClass: "panel-switch",
        labelCustomClass: "panel-switch-label",
        label: (0, _preact.h)(_LabelText.default, {
          label: "Custom CSS",
          description: "Switching this off will disable the display of the option Custom CSS in Themes in the destination and hide the self service page Custom CSS in control. Previously added custom CSS will not be applied in the destination. However, previously added custom CSS is not deleted and will be applied if this module is enabled again."
        }),
        on: modules.customCss,
        onChange: function onChange() {
          return _this3.setState({
            modules: Object.assign(modules, {
              customCss: !modules.customCss
            })
          });
        }
      }), (0, _preact.h)(_Switcher.default, {
        customClass: "panel-switch",
        labelCustomClass: "panel-switch-label",
        label: (0, _preact.h)(_LabelText.default, {
          label: "Third party scripts",
          description: "Switching this off will disable the self-service page in control to add third party scripts. Previously added custom CSS will not be applied in the destination. However, previously added third party scripts are not deleted and will be applied if this module is enabled again."
        }),
        on: modules.thirdPartyScripts,
        onChange: function onChange() {
          return _this3.setState({
            modules: Object.assign(modules, {
              thirdPartyScripts: !modules.thirdPartyScripts
            })
          });
        }
      })), (0, _preact.h)(_Section.Section, {
        title: "Platform"
      }, (0, _preact.h)(_Switcher.default, {
        customClass: "panel-switch",
        labelCustomClass: "panel-switch-label",
        label: (0, _preact.h)(_LabelText.default, {
          label: "Groups",
          description: "Switching this off will disable the self service page in control to setup and manage groups. On destination the group widget and group overview page will be hidden. All content in groups will be hidden from search."
        }),
        on: modules.group,
        onChange: function onChange() {
          return _this3.setState({
            modules: Object.assign(modules, {
              group: !modules.group
            })
          });
        }
      }), (0, _preact.h)(_Switcher.default, {
        customClass: "panel-switch",
        labelCustomClass: "panel-switch-label",
        label: (0, _preact.h)(_LabelText.default, {
          label: "Private groups",
          description: "Switching this off will remove the private groups setting from the groups creation. Private groups will not be visible on the groups overview page and will be removed from search results. It will not be possible to publish events in private groups."
        }),
        on: modules.privateGroup,
        onChange: function onChange() {
          return _this3.setState({
            modules: Object.assign(modules, {
              privateGroup: !modules.privateGroup
            })
          });
        }
      }), (0, _preact.h)(_Switcher.default, {
        customClass: "panel-switch",
        labelCustomClass: "panel-switch-label",
        label: (0, _preact.h)(_LabelText.default, {
          label: "Hidden groups",
          description: "Switching this off will remove the hidden group type from the group creation form. Hidden groups will not be visible by their members."
        }),
        on: modules.hiddenGroup,
        onChange: function onChange() {
          return _this3.setState({
            modules: Object.assign(modules, {
              hiddenGroup: !modules.hiddenGroup
            })
          });
        }
      }), (0, _preact.h)(_Switcher.default, {
        customClass: "panel-switch",
        labelCustomClass: "panel-switch-label",
        label: (0, _preact.h)(_LabelText.default, {
          label: "Ideation module",
          description: "Switching this off will remove Ideation from the Platform sidebar navigation in Control."
        }),
        on: modules.ideationV2,
        onChange: function onChange() {
          return _this3.setState({
            modules: Object.assign(modules, {
              ideationV2: !modules.ideationV2
            })
          });
        }
      }), (0, _preact.h)(_Switcher.default, {
        customClass: "panel-switch",
        labelCustomClass: "panel-switch-label",
        label: (0, _preact.h)(_LabelText.default, {
          label: "Product Updates",
          description: "Switching this off will hide the product updates module."
        }),
        on: modules.productUpdates,
        onChange: function onChange() {
          return _this3.setState({
            modules: Object.assign(modules, {
              productUpdates: !modules.productUpdates
            })
          });
        }
      }), (0, _preact.h)(_Switcher.default, {
        customClass: "panel-switch",
        labelCustomClass: "panel-switch-label",
        label: (0, _preact.h)(_LabelText.default, {
          label: "Article to product updates conversion",
          description: "Switching this on will allow customer to convert articles to product update from article topic moderation page at control."
        }),
        on: modules.articleToProductUpdateConversion,
        onChange: function onChange() {
          return _this3.setState({
            modules: Object.assign(modules, {
              articleToProductUpdateConversion: !modules.articleToProductUpdateConversion
            })
          });
        }
      }), (0, _preact.h)(_Switcher.default, {
        customClass: "panel-switch",
        labelCustomClass: "panel-switch-label",
        label: (0, _preact.h)(_LabelText.default, {
          label: "Product Areas",
          description: "Switching this off will disable the self-service page in control to setup and manage Product areas. Product areas will not appear in Ideas and Product updates modules in Control and Destination. Switching this off will remove public tags from the Ideas and Product updates modules in Control and Destination."
        }),
        on: modules.productAreas,
        onChange: function onChange() {
          return _this3.setState({
            modules: Object.assign(modules, {
              productAreas: !modules.productAreas
            })
          });
        }
      })), (0, _preact.h)(_Section.Section, {
        title: "Integrations"
      }, (0, _preact.h)(_Switcher.default, {
        customClass: "panel-switch",
        labelCustomClass: "panel-switch-label",
        label: (0, _preact.h)(_LabelText.default, {
          label: "API",
          description: "Switching this off will disable the self service page in control which can be used to generate oAuth2 credentials required to connect with the ".concat(_constants.PLATFORM_BRAND_NAME, " API. Previously generated oauth2 credentails will be revoked.")
        }),
        on: modules.integrationsApi,
        onChange: function onChange() {
          return _this3.setState({
            modules: Object.assign(modules, {
              integrationsApi: !modules.integrationsApi
            })
          });
        }
      }), (0, _preact.h)(_Switcher.default, {
        customClass: "panel-switch",
        labelCustomClass: "panel-switch-label",
        label: (0, _preact.h)(_LabelText.default, {
          label: "Connectors & Secrets",
          description: "Switching this off will disable the Connectors & Secrets page in control which can be used to manage external integrations and store API keys securely."
        }),
        on: modules.integrationsConnectorsAndSecrets,
        onChange: function onChange() {
          return _this3.setState({
            modules: Object.assign(modules, {
              integrationsConnectorsAndSecrets: !modules.integrationsConnectorsAndSecrets
            })
          });
        }
      }), (0, _preact.h)(_Switcher.default, {
        customClass: "panel-switch",
        labelCustomClass: "panel-switch-label",
        label: (0, _preact.h)(_LabelText.default, {
          label: "AI Evolution Reply Bot",
          description: "Switching this off will disable the AI Evolution Reply Bot page in control which provides automated reply capabilities powered by AI."
        }),
        on: modules.aiEvolutionReplyBot,
        onChange: function onChange() {
          return _this3.setState({
            modules: Object.assign(modules, {
              aiEvolutionReplyBot: !modules.aiEvolutionReplyBot
            })
          });
        }
      }), (0, _preact.h)(_Switcher.default, {
        customClass: "panel-switch",
        labelCustomClass: "panel-switch-label",
        label: (0, _preact.h)(_LabelText.default, {
          label: "Open Federated Search API",
          description: "Switching this off will disable the Open Federated Search integrations built using the API. Results from the integrated content will not be visible in search in destination"
        }),
        on: modules.federatedSearchApi,
        onChange: function onChange() {
          return _this3.setState({
            modules: Object.assign(modules, {
              federatedSearchApi: !modules.federatedSearchApi
            })
          });
        }
      })), (0, _preact.h)(_Section.Section, {
        title: "Localization Features"
      }, (0, _preact.h)(_Switcher.default, {
        customClass: "panel-switch",
        labelCustomClass: "panel-switch-label",
        label: (0, _preact.h)(_LabelText.default, {
          label: "Language-Specific Categories",
          description: "Enable admins to create and manage categories in each enabled language. This ensures content is organized by language and displayed appropriately to users based on their language settings."
        }),
        on: modules.contentInPreferredLanguage,
        onChange: function onChange() {
          return _this3.setState({
            modules: Object.assign(modules, {
              contentInPreferredLanguage: !modules.contentInPreferredLanguage
            })
          });
        }
      }), (0, _preact.h)(_Switcher.default, {
        customClass: "panel-switch",
        labelCustomClass: "panel-switch-label",
        label: (0, _preact.h)(_LabelText.default, {
          label: "AI Translations for Community Threads",
          description: "\tEnable on-demand AI translations for topics and replies, providing a more inclusive experience for users across different languages."
        }),
        on: modules.onDemandTranslations,
        onChange: function onChange() {
          return _this3.setState({
            modules: Object.assign(modules, {
              onDemandTranslations: !modules.onDemandTranslations
            })
          });
        }
      })));
    }
  }]);
  return CommunityConfiguration;
}(_preact.Component);

var _default = CommunityConfiguration;
exports.default = _default;